import type { ContactSessionStatus } from "@wags/profile-contracts/contact-session.contract.ts";

export const KITS_RECEIVED_SESSION_STATUSES = [
    "kits_connected",
    "provider_email_sent",
    "awaiting_provider_response",
    "escalated_to_admin",
] as const satisfies readonly ContactSessionStatus[];
